import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoPanelComponent } from './video-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [VideoPanelComponent],
  exports: [VideoPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class VideoPanelModule { }
